<h2 mat-dialog-title>{{ getDialogTitle() }}</h2>

<mat-dialog-content>
  <div *ngIf="loading()" class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Lade verfügbare Optionen...</p>
  </div>

  <form [formGroup]="moveForm" *ngIf="!loading()">
    <div class="d-flex flex-column">
      <!-- Category Dropdown -->
      <mat-form-field *ngIf="showCategoryDropdown()" appearance="fill" class="full-width">
        <mat-label>Prozessschritt auswählen</mat-label>
        <mat-select formControlName="categoryId" required>
          <mat-option *ngFor="let category of categories()" [value]="category.id">
            {{ category.name }}
          </mat-option>
        </mat-select>
        <!--<mat-error *ngIf="moveForm.get('categoryId')?.hasError('required')">
          Prozessschritt ist erforderlich
        </mat-error>-->
      </mat-form-field>

      <!-- Malfunction Dropdown -->
      <mat-form-field *ngIf="showMalfunctionDropdown()" appearance="fill" class="full-width">
        <mat-label>Störung auswählen</mat-label>
        <mat-select formControlName="malfunctionId" required [disabled]="!moveForm.get('categoryId')?.value">
          <mat-option *ngFor="let malfunction of malfunctions()" [value]="malfunction.id">
            {{ malfunction.name }}
          </mat-option>
        </mat-select>
        <!--<mat-error *ngIf="moveForm.get('malfunctionId')?.hasError('required')">
          Störung ist erforderlich
        </mat-error>-->
      </mat-form-field>
    </div>


    <div *ngIf="showMalfunctionDropdown() && !moveForm.get('categoryId')?.value" class="info-text">
      Bitte wählen Sie zuerst einen Prozessschritt aus.
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="d-flex gap-2">
  <button mat-button (click)="onCancel()">Abbrechen</button>
  <button
    class="btn btn-qundis-primary"
    (click)="onMove()"
    [disabled]="!moveForm?.valid || loading()">
    Verschieben
  </button>
</mat-dialog-actions>
